// Check if we are on a collections page.
if (window.location.pathname.includes("/collections/")) {
    // Extract the collection title from the URL.
  const urlParts = window.location.pathname.split("/");
  const lastPart = urlParts[urlParts.length - 1];
     
  const collectionTitle= document.getElementById("custom_breadcrumb").value ;
 
    localStorage.setItem("collectionTitle", collectionTitle);
  
    // Save the collections page URL to localStorage.
  const collectionHref = window.location.href;
  localStorage.setItem("collectionHref", collectionHref);
  } else if (window.location.pathname.includes("/products/")) {
    
  }
  else{
     
    // localStorage.removeItem("collectionTitle");
    // localStorage.removeItem("collectionHref");
  }